import styled from "styled-components"

const YellowGradientLine = styled.div`
  height: 3px;
  width: 100%;
  background: linear-gradient(90deg, #eabb90 0%, #f3eb73 100%);
`

export default YellowGradientLine
